import {
  takeLatest,
  put,
  call,
} from 'redux-saga/effects';

import {
  delay,
} from 'redux-saga';

import types from '../types';
import actions from '../actions';

import { getBrowseApi } from '../../../api';

const maxRetries = 3;

export function* getBrowsePageDataFlow() {
  let retry = true;
  let retryCount = 0;

  do {
    try {
      const response = yield call(getBrowseApi);
      yield put(
        actions.getBrowsePageDataSucceeded(
          response.data.data,
        ),
      );
      retry = false;
    } catch (error) {
      retryCount += 1;
      retry = [503, 504].includes(error.response.status) ? retryCount < maxRetries : false;
      yield put(
        actions.getBrowsePageDataFailed(
          {
            ...error,
            retry: {
              count: retryCount,
              retry,
            },
          },
        ),
      );

      if (retry) {
        yield call(delay, 2000);
      }
    }
  } while (retry);
}

export function* watchGetBrowsePageDataRequested() {
  yield takeLatest(
    types.GET_BROWSE_PAGE_DATA_REQUESTED,
    getBrowsePageDataFlow,
  );
}

export default watchGetBrowsePageDataRequested;
